import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { EnterpriseCityTableModel } from 'src/app/models/tables/management/enterprise-city-table.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { EnterpriseCityModel } from './../../../../models/management/enterprise-city.model';
import { EnterpriseModel } from './../../../../models/management/enterprise.model';
import { EnterpriseCityService } from './../../../../services/management/enterprise-city.service';

@Component({
  selector: 'app-enterprise-city',
  templateUrl: './enterprise-city.component.html',
  styleUrls: ['./enterprise-city.component.scss'],
  standalone: false
})
export class EnterpriseCityComponent implements OnInit {

  enterpriseContract: EnterpriseModel = new EnterpriseModel();
  disabledDetail: boolean = false;
  disabledActions: boolean = false;
  permissionUpdatable: boolean = false;
  ascendant: boolean = true;
  columnSort: string | null = null;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  data: PagedResponseModel<EnterpriseCityTableModel> = new PagedResponseModel<EnterpriseCityTableModel>();
  header: ColumnResponseModel[] = [];
  enterpriseCityContract: EnterpriseCityModel = new EnterpriseCityModel();
  filters: ColumnResponseModel[] = [];
  isFormView: boolean = false;
  limit: number = 10;
  page: number = 1;
  suscription: Subscription;
  tableActions: TableAction[] = [];

  constructor(private confirmDialogService: ConfirmDialogService,
    private enterpriseCityService: EnterpriseCityService,
    private toastHandlerService: ToastHandlerService,
    public config: DynamicDialogConfig) { }

  async ngOnInit(): Promise<void> {
    this.tableActions = this.getDefaultActions();
    await Promise.all([
      this.getColumns(),
      this.getAllEnterpriseCitiesWithPagination()
    ]);

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.enterpriseContract = inputs.enterpriseContract;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledDetail = inputs.disabledForm;
      this.disabledActions = inputs.disabledForm;
    });
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async createNew() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear códigos ciudades.
        Comuníquese con el administrador del sistema.`);
      return;
    }

    this.enterpriseCityContract = new EnterpriseCityModel();
    this.getFormView(true);
  }

  async onAction(event: { action: string, item?: EnterpriseCityTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      try {
        this.enterpriseCityContract = await firstValueFrom(this.enterpriseCityService.getEnterpriseCityById(event.item.id));
        this.isFormView = true;
      } catch (error) {
        console.error('Error al editar el registro.', error);
      }
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      if (await this.confirmDialogService.confirm("¿Realmente desea eliminar el registro seleccionado?")) {
        try {
          await firstValueFrom(this.enterpriseCityService.deleteSomeDetails(event.selectedItems));
          this.enterpriseCityContract = new EnterpriseCityModel();
          this.toastHandlerService.showToast(
            'success',
            'El registro fue eliminado exitosamente.'
          );
          this.enterpriseCityContract = new EnterpriseCityModel();
          this.clearSelectionTrigger++;
          this.getAllEnterpriseCitiesWithPagination();
        } catch (error) {
          console.error('Error al eliminar los registros seleccionados.', error);
        }
      }
    }
  }

  async exportGeneralConsultation() {
    try {
      const blob = await firstValueFrom(
        this.enterpriseCityService.exportEnterpriseCitiesConsultation(
          this.filters,
          this.columnSort,
          this.ascendant
        )
      );
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Codigos ciudades.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar las ciudades.', error);
    }
  }

  async getColumns() {
    try {
      this.header = await firstValueFrom(this.enterpriseCityService.getColumnsForConsultation());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  async getAllEnterpriseCitiesWithPagination() {
    try {
      this.data = await firstValueFrom(this.enterpriseCityService.getAllEnterpriseCitiesWithPagination(this.page, this.limit, this.columnSort, this.ascendant,
        this.filters));
    } catch (error) {
      console.error('Error al buscar las ciudades.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }


  getUpdateListDetailByDelete() {
    this.enterpriseCityContract = new EnterpriseCityModel();
    this.clearSelectionTrigger++;
    this.getAllEnterpriseCitiesWithPagination();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);
    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  private removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getAllEnterpriseCitiesWithPagination();
  }

  private processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filters = this.filters.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filters.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }
}
